import React from 'react';
import PropTypes from 'prop-types';

function Clickable(props) {
  const { children, opportunityIds, onSelect } = props;
  if (opportunityIds && opportunityIds.length) {
    return (
      <a
        href=""
        onClick={(e) => {
          e.preventDefault();
          onSelect(opportunityIds);
        }}
      >
        {children}
      </a>
    );
  }
  return children;
}
Clickable.propTypes = {
  children: PropTypes.node,
  opportunityIds: PropTypes.arrayOf(PropTypes.string), 
  onSelect: PropTypes.func,
};
Clickable.defaultProps = {
  children: null,
  onSelect: () => {},
  opportunityIds: null,
};

export default Clickable;
